import React from 'react';
import PropTypes from 'prop-types';

const MaxRepeat = (props) => {
  const {
    updateField, active, value, disabled,
  } = props;
  return (
    <div style={{ width: '110px' }}>
      <div className="row form-inline">
        <span className="col-12" style={{ fontWeight: 'bold', fontSize: '15px' }}>Max Repeat</span>
      </div>
      <div className="row form-inline-block">
        <div className="col-12">
          <input
            className="form-check mr-2 mx-2 d-inline"
            onChange={(e) => {
              updateField('maxRepeatEnabled', (e.target.checked));
            }}
            type="checkbox"
            checked={active}
            disabled={disabled}
            aria-label="enable max repeat"
          />
          <input
            className="form-control mx-2 d-inline"
            onChange={(e) => {
              updateField('maxReminders', (e.target.value));
            }}
            disabled={disabled || !active}
            value={value}
            type="text"
            style={{ width: '4em' }}
            aria-label="max repeat number"
          />
        </div>
      </div>
    </div>
  );
};

MaxRepeat.propTypes = {
  updateField: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};
export default MaxRepeat;
